<template>
  <div class="title-container">
    <div class="title-content">
      <springText class="item-title" text="Game"></springText>
      <springText class="item-title" text="Release"></springText>
      <springText class="item-title" text="Regions"></springText>
    </div>
    <div class="sub-title">
      <springText text="MATR1X FIRE is loved by players around the world."></springText>
    </div>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";
import springText from "@/views/components/springText";

export default {
  mixins: [responsiveMixin],
  components: { springText },
  data() {
    return {};
  },
  mounted() { },
  methods: {},
  watch: {

  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>